// css =>
import Styled from "./SpinnerBar.module.css";

function SpinnerBar() {
    return (
        <div className={ Styled.Spinner }>
            <div className={ Styled.Head }></div>
        </div>
    );
}

export default SpinnerBar;
